import { ISearchData, ISearchAction } from 'models/search/search';
import { IProductBaseSearchResultsData } from 'models/search/productbasesearchresults';
import * as c from 'models/constants';
import { resetSearchData as resetUserData } from 'redux/modules/search/usersearchresults';
import { resetSearchData as resetArticleData } from 'redux/modules/search/articlesearchresults';
import {
	resetSearchData as resetProductData,
	setProductSelectedCategory,
	getProductSearchResults,
	setProductSortOrder,
	setProductSearchResultsFilters,
} from 'redux/modules/search/productsearchresults';
import { IUserLanguage } from 'models/user/userlanguage';
import { IStore } from 'redux/IStore';
import { actions as notifActions } from 'redux-notifications';
import { getUserSearchResults, setUserSearchKeyword } from 'redux/modules/search/usersearchresults';
import { getArticleSearchResultsAll, setArticleSearchKeyword } from 'redux/modules/search/articlesearchresults';
import { setProductSearchKeyword } from '../productsearchresults';
import { IRefinementGroup, IRefinement } from 'models/filtering/refinement';
import { SearchUsage, ProductRefinementGroupings } from '../../../../models';
import { getShopSearchResults } from '../shopsearchresults';
const { notifSend } = notifActions;

/** Action Types */
export const RESET_DATA: string = 'search/RESET_DATA';
export const SET_SEARCH_KEYWORD: string = 'search/SET_SEARCH_KEYWORD';
export const CHANGE_SELECTED_TAB: string = 'search/CHANGE_SELECTED_TAB';

/** Initial State */
const initialState: ISearchData = {
	selectedTab: c.SEARCHRESULTS_TAB_PRODUCT,
	keyword: '',
};

/** Reducer */
export function searchReducer(state = initialState, action: ISearchAction) {
	switch (action.type) {
		case SET_SEARCH_KEYWORD:
			return Object.assign({}, state, {
				keyword: action.payload.keyword,
			});

		case RESET_DATA:
			return Object.assign({}, state, {
				keyword: '',
				selectedTab: c.SEARCHRESULTS_TAB_PRODUCT,
			});

		case CHANGE_SELECTED_TAB:
			return Object.assign({}, state, {
				selectedTab: action.payload.selectedTab,
			});

		default:
			return state;
	}
}

export function resetSearchData() {
	return (dispatch) => {
		dispatch(resetData());
		dispatch(resetUserData());
		dispatch(resetArticleData());
		dispatch(resetProductData());
	};
}

/** Action Creator */
export function resetData(): ISearchAction {
	return {
		type: RESET_DATA,
	};
}

/** Action Creator */
export function setSearchKeyword(keyword: string): ISearchAction {
	return {
		type: SET_SEARCH_KEYWORD,
		payload: {
			keyword,
		},
	};
}

export function changeSearchSelectedTab(selectedTab: string): ISearchAction {
	return {
		type: CHANGE_SELECTED_TAB,
		payload: {
			selectedTab,
		},
	};
}

export function changeTabAndGetRequiredData(
	selectedTab: string,
	categoryId: number,
	keyword: string,
	order: number,
	r1: number,
	r2: number,
	r3: boolean,
	r4: string,
	r5: string,
) {
	return (dispatch, getState: () => IStore) => {
		dispatch(changeSearchSelectedTab(selectedTab));
		keyword = keyword || '';

		const language: IUserLanguage = getState().userLanguage;

		if (keyword !== getState().search.keyword) {
			dispatch(setSearchKeyword(keyword));
		}

		switch (selectedTab) {
			case c.SEARCHRESULTS_TAB_USER:
				if (keyword !== getState().userSearchResults.keyword) {
					dispatch(getUserSearchResults(true, keyword));
					dispatch(setUserSearchKeyword(keyword));
				}
				break;

			case c.SEARCHRESULTS_TAB_ARTICLE:
				if (keyword !== getState().articleSearchResults.keyword) {
					dispatch(getArticleSearchResultsAll(true, keyword, 'search/:keyword', '', language.languageKey));
					dispatch(setArticleSearchKeyword(keyword));
				}
				break;

			case c.SEARCHRESULTS_TAB_SHOP:
				dispatch(getShopSearchResults(true, keyword));
				break;

			case c.SEARCHRESULTS_TAB_PRODUCT:
			case c.SEARCHRESULTS_TAB_PRODUCT2: {
				//if any parameter is changed - reset search data and repopulate reducer
				//check refinements complex object
				let r: string = null;
				let currentPricesRefinementGroup: string = null;
				let prevPricesRefinementGroup: string = null;
				let refinementSelections: string = null;
				let refinementUrl: IProductBaseSearchResultsData = null;
				if (
					getState().productSearchResults.refinementSelections &&
					getState().productSearchResults.refinementSelections.length
				) {
					const temp: IRefinementGroup[] = [];
					getState().productSearchResults.refinementSelections.forEach((reducerRefinementGroup: IRefinementGroup) => {
						const refinementGroup: IRefinementGroup = {};
						refinementGroup.groupId = reducerRefinementGroup.groupId;
						refinementGroup.refinements = [];
						reducerRefinementGroup.refinements.forEach((reducerRefinement: IRefinement) => {
							const irefinement: IRefinement = { id: reducerRefinement.id };
							refinementGroup.refinements.push(irefinement);
						});
						if (refinementGroup && refinementGroup.refinements.length) {
							temp.push(refinementGroup);
						}
					});
					r = new URLSearchParams(JSON.stringify(temp)).toString();
				}
				//we need only price group because it is a hack and stored in refinement group and not in selections
				if (
					getState().productSearchResults.refinementGroups &&
					getState().productSearchResults.refinementGroups.length
				) {
					const temp: IRefinementGroup[] = [];
					getState()
						.productSearchResults.refinementGroups.filter((x) => x.groupId === ProductRefinementGroupings.Price)
						.forEach((reducerRefinementGroup: IRefinementGroup) => {
							const refinementGroup: IRefinementGroup = {};
							refinementGroup.groupId = reducerRefinementGroup.groupId;
							refinementGroup.refinements = [];
							reducerRefinementGroup.refinements.forEach((reducerRefinement: IRefinement) => {
								const irefinement: IRefinement = { id: reducerRefinement.id };
								refinementGroup.refinements.push(irefinement);
							});
							if (refinementGroup && refinementGroup.refinements.length) {
								temp.push(refinementGroup);
							}
						});
					currentPricesRefinementGroup = new URLSearchParams(JSON.stringify(temp)).toString();
				}
				if (r1 && r2) {
					refinementUrl = {};
					refinementUrl.lastSelectedRefinementItemId = r1;
					refinementUrl.lastSelectedRefinementGroupId = r2;
					refinementUrl.lastActionWasToNarrowRefinement = r3;
					refinementUrl.refinementGroups = [];
					refinementUrl.refinementSelections = [];
					if (r4 && r4.length) {
						r4.split('g').forEach((group: string) => {
							if (group && group.length) {
								const refinementGroup: IRefinementGroup = {};
								const groupId: number = parseInt(group.substr(0, 1), 10);
								refinementGroup.groupId = groupId;
								refinementGroup.refinements = [];
								group
									.substr(1)
									.split('r')
									.forEach((refinement: string) => {
										if (refinement && refinement.length) {
											const refinementId: number = parseInt(refinement.substr(0), 10);
											const irefinement: IRefinement = { id: refinementId };
											refinementGroup.refinements.push(irefinement);
										}
									});
								if (refinementGroup && refinementGroup.refinements.length) {
									refinementUrl.refinementSelections.push(refinementGroup);
								}
							}
						});
					}
					if (r5 && r5.length) {
						r5.split('g').forEach((group: string) => {
							if (group && group.length) {
								const refinementGroup: IRefinementGroup = {};
								const groupId: number = parseInt(group.substr(0, 1), 10);
								refinementGroup.groupId = groupId;
								refinementGroup.refinements = [];
								group
									.substr(1)
									.split('r')
									.forEach((refinement: string) => {
										if (refinement && refinement.length) {
											const refinementId: number = parseInt(refinement.substr(0), 10);
											const irefinement: IRefinement = { id: refinementId };
											refinementGroup.refinements.push(irefinement);
										}
									});
								if (refinementGroup && refinementGroup.refinements.length) {
									refinementUrl.refinementGroups.push(refinementGroup);
								}
							}
						});
						prevPricesRefinementGroup = new URLSearchParams(
							JSON.stringify(
								refinementUrl.refinementGroups.filter((x) => x.groupId === ProductRefinementGroupings.Price),
							),
						).toString();
					}
					refinementSelections = new URLSearchParams(JSON.stringify(refinementUrl.refinementSelections)).toString();
				} else if (r5 && r5.length) {
					refinementUrl = {};
					refinementUrl.lastSelectedRefinementItemId = null;
					refinementUrl.lastSelectedRefinementGroupId = null;
					refinementUrl.lastActionWasToNarrowRefinement = false;
					refinementUrl.refinementGroups = [];
					refinementUrl.refinementSelections = [];
					r5.split('g').forEach((group: string) => {
						if (group && group.length) {
							const refinementGroup: IRefinementGroup = {};
							const groupId: number = parseInt(group.substr(0, 1), 10);
							refinementGroup.groupId = groupId;
							refinementGroup.refinements = [];
							group
								.substr(1)
								.split('r')
								.forEach((refinement: string) => {
									if (refinement && refinement.length) {
										const refinementId: number = parseInt(refinement.substr(0), 10);
										const irefinement: IRefinement = { id: refinementId };
										refinementGroup.refinements.push(irefinement);
									}
								});
							if (refinementGroup && refinementGroup.refinements.length) {
								refinementUrl.refinementGroups.push(refinementGroup);
							}
						}
					});
					prevPricesRefinementGroup = new URLSearchParams(
						JSON.stringify(
							refinementUrl.refinementGroups.filter((x) => x.groupId === ProductRefinementGroupings.Price),
						),
					).toString();
				}

				if (
					keyword !== getState().productSearchResults.keyword ||
					(categoryId !== getState().productSearchResults.selectedCategoryId && categoryId !== null) ||
					order !== getState().productSearchResults.sortOrder ||
					refinementSelections !== r ||
					(prevPricesRefinementGroup !== currentPricesRefinementGroup && prevPricesRefinementGroup !== null) //hack because always returns price refinment
				) {
					dispatch(resetProductData());
					dispatch(setProductSearchKeyword(keyword));
					if (categoryId !== null) {
						dispatch(setProductSelectedCategory(categoryId));
					}
					dispatch(setProductSortOrder(order));

					if (refinementUrl) {
						dispatch(setProductSearchResultsFilters(refinementUrl));
					}

					if (categoryId) {
						if (refinementUrl) {
							dispatch(getProductSearchResults(true, true, SearchUsage.ProductsSearch));
						} else {
							dispatch(getProductSearchResults(true, false, SearchUsage.ProductsSearch));
						}
					}
				}
				break;
			}
			default:
				dispatch(getUserSearchResults(true, keyword));
		}
	};
}

/** Action Creator */
export function updateIndex() {
	return (dispatch, getState: () => IStore) => {
		return fetch(
			getState().fetchDefault.baseAPI + 'api/Search',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
			}),
		).then((res) => {
			if (res.ok) {
				dispatch(notifSend({ message: 'Index update request sent', kind: 'success', dismissAfter: 3000 }));
			} else {
				dispatch(
					notifSend({ message: 'Index update request failed ' + res.statusText, kind: 'warning', dismissAfter: 3000 }),
				);
			}
		});
	};
}
